import Button from "@/components/Button";
import { addAlert } from "@/redux/message/messageSlice";
import { AppDispatch } from "@/redux/store";
import {
  TacticsResponses,
  deleteTactic,
  setDeleteTacticStatusIdle,
} from "@/redux/tactics/tacticsSlice";
import { Trans, useTranslation } from "@repo/shared/i18n";
import { useEffect } from "react";
import { Oval } from "react-loading-icons";
import { useDispatch } from "react-redux";

import ActionModal from "../ActionModal";

interface DeleteTacticsActionModalProps {
  onDismiss: () => void;
  tacticId: string;
  responses: TacticsResponses;
}

const DeleteTacticsActionModal = ({
  onDismiss,
  tacticId,
  responses,
}: DeleteTacticsActionModalProps) => {
  const { t } = useTranslation(["players", "common"]);
  const dispatch = useDispatch<AppDispatch>();

  const handleDelete = () => {
    dispatch(deleteTactic(tacticId));
  };
  const handleDismiss = () => {
    dispatch(setDeleteTacticStatusIdle());
    onDismiss();
  };

  useEffect(() => {
    if (responses.deleteTactic.status === "fulfilled") {
      dispatch(
        addAlert({
          description: t("tactics.deleteModal.deleted"),
          type: "success",
        }),
      );
      dispatch(setDeleteTacticStatusIdle());
      handleDismiss();
    }
  }, [responses.deleteTactic.status]);

  return (
    <ActionModal
      onDismiss={handleDismiss}
      title={t("tactics.deleteModal.title")}
      size="small"
    >
      <div className="flex flex-col gap-y-6 mt-6 items-center">
        <p className="text-gray-200">
          <Trans
            ns="players"
            i18nKey="tactics.deleteModal.body"
            components={{ br: <br /> }}
          />
        </p>
        <div className="flex flex-row gap-x-2">
          <Button
            onClick={handleDismiss}
            variant="tertiary"
            label={t("common:cancel")}
          />
          <Button
            onClick={handleDelete}
            variant="primary"
            label={
              responses.deleteTactic.status === "pending" ? (
                <Oval width={20} height={20} />
              ) : (
                t("common:delete")
              )
            }
          />
        </div>
        {responses.deleteTactic.message && (
          <span className="text-red-500 text-xs">
            {responses.deleteTactic.message}
          </span>
        )}
      </div>
    </ActionModal>
  );
};

export default DeleteTacticsActionModal;
